import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/modules/layouts/mdx_layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Accordion = makeShortcode("Accordion");
const Button = makeShortcode("Button");
const Checklist = makeShortcode("Checklist");
const Box = makeShortcode("Box");
const Chocolate = makeShortcode("Chocolate");
const Icon = makeShortcode("Icon");
const List = makeShortcode("List");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Component Palette`}</h1>
    <p>{`This page serves as a palette for all the components this project has to offer.`}</p>
    <hr></hr>
    <h4>{`Definitions`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`WYSIWYG`}</strong>{`: What you see is what you get.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Component`}</strong>{`: A lego block like code element you can use for more advanced content like buttons.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`MD`}</strong>{`: Shorthand for Markdown`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`MDX`}</strong>{`: Shorthand for MarkdownExtended (ie. MDX is the name of the rendering engine we use.)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Child/Children`}</strong>{`: Content that is wrapped by a Component. New lines between content will be recognized as a new child.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Child Rule`}</strong>{`: A pattern introduced for more complex components that recognized each individual child as a repeatable element of a component. (ie. List, Checklist, ect.)`}</p>
      </li>
    </ul>
    <hr></hr>
    <h4>{`Disclaimers`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`This palette is primarily to showcase component usage in a vacuum, and to act as helpers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Always remember. What you see is what you get. (WYSIWYG). We follow the markdown spec.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`There's no mobile styles for these really. Use at your own risk.`}</p>
      </li>
    </ul>
    <hr></hr>
    <h1>{`Accordion`}</h1>
    <p>{`Click the Accordion header to show and hide the content it offers.`}</p>
    <p>{`The first element is always the header. Every other element will be hidden away.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<Accordion>Hello World This is hidden inside the Accordion.</Accordion>
`}</code></pre>
    <hr></hr>
    <Accordion mdxType="Accordion">
      <p>{`Hello World`}</p>
      <p>{`This is hidden inside the Accordion.`}</p>
    </Accordion>
    <hr></hr>
    <h1>{`Button`}</h1>
    <p>{`It's a button. Not much more to it.`}</p>
    <p><strong parentName="p">{`Dev Note(Réjon): Because this site doesn't provide any stateful functionality (besides light/dark modes), Buttons are built to serve as a unique visual display of links.`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<Button to="/"> ET phone Home </Button>
`}</code></pre>
    <hr></hr>
    <Button to="/" mdxType="Button"> ET phone Home </Button>
    <hr></hr>
    <h1>{`Checklist`}</h1>
    <h4>{`Child Rule in Effect`}</h4>
    <p>{`This is a non-functioning checklist component. It is simply styled to look like one.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<Checklist>
  Child A Child B
  <Box>
    Child C
  </Box>
</Checklist>
`}</code></pre>
    <hr></hr>
    <Checklist mdxType="Checklist">
      <p>{`Child A`}</p>
      <p>{`Child B`}</p>
      <Box mdxType="Box">
        <p>{`Child C`}</p>
      </Box>
    </Checklist>
    <hr></hr>
    <h1>{`Chocolate (Box)`}</h1>
    <h4>{`Child Rule in Effect`}</h4>
    <p>{`Originally named "Chocolate Box" components, this component takes into consideration the child rule.
Each child is recognized as a new element. Thus it's recommended for more diverse content to be contained
by a `}<inlineCode parentName="p">{`Box`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<Chocolate>
  <Box>
    <Icon size={"40px"} name="maker" />
    ##### Child A Some content about something
  </Box>

  <Box>
    <Icon size={"40px"} name="globe" />
    ##### Child B Some content about something
  </Box>

  <Box>
    <Icon size={"40px"} name="wrench" />
    ##### Child C Some content about something
  </Box>
</Chocolate>
`}</code></pre>
    <hr></hr>
    <Chocolate mdxType="Chocolate">
      <Box mdxType="Box">
        <Icon size={"40px"} name="maker" mdxType="Icon" />
        <h5>{`Child A`}</h5>
        <p>{`Some content about something`}</p>
      </Box>
      <Box mdxType="Box">
        <Icon size={"40px"} name="globe" mdxType="Icon" />
        <h5>{`Child B`}</h5>
        <p>{`Some content about something`}</p>
      </Box>
      <Box mdxType="Box">
        <Icon size={"40px"} name="wrench" mdxType="Icon" />
        <h5>{`Child C`}</h5>
        <p>{`Some content about something`}</p>
      </Box>
    </Chocolate>
    <hr></hr>
    <h1>{`List`}</h1>
    <p>{`The List component is great if you want to display content...in the form of....a list.`}</p>
    <h4>{`Child Rule in Effect`}</h4>
    <p><strong parentName="p">{`To get the most out of lists (ie. headers, subcontent, links) you MUST use a `}<inlineCode parentName="strong">{`Box`}</inlineCode>{` or `}<inlineCode parentName="strong">{`Link`}</inlineCode>{` component
based on your specific needs.`}</strong></p>
    <hr></hr>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<List>

Element A

Element B

</List>

<List>

<Box>

Element A Header

Some content below the header

</Box>

Element B with no subcontent

<Box>

Element C Header

Some content below the header

</Box>

</List>

<List>

<Link to="/">

Link Element A Header

Some content below the header

</Link>

<Link to="https://makerdao.com/">

External Link Element B Header

Some content below the header

</Link>

</List>
`}</code></pre>
    <hr></hr>
    <List mdxType="List">
      <p>{`Element A`}</p>
      <p>{`Element B`}</p>
    </List>
    <hr></hr>
    <List mdxType="List">
      <Box mdxType="Box">
        <p>{`Element A Header`}</p>
        <p>{`Some content below the header`}</p>
      </Box>
      <p>{`Element B with no subcontent`}</p>
      <Box mdxType="Box">
        <p>{`Element C Header`}</p>
        <p>{`Some content below the header`}</p>
      </Box>
    </List>
    <hr></hr>
    <List mdxType="List">
      <Link to="/" mdxType="Link">
        <p>{`Link Element A Header`}</p>
        <p>{`Some content below the header`}</p>
      </Link>
      <Link to="https://makerdao.com/" mdxType="Link">
        <p>{`External Link Element B Header`}</p>
        <p>{`Some content below the header`}</p>
      </Link>
    </List>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      